export default __webpack_public_path__ + "static/media/logo-white-blue.58048bc1.svg";